import { render } from "./AdditionalData.vue?vue&type=template&id=b3315e42&scoped=true"
import script from "./AdditionalData.vue?vue&type=script&lang=js"
export * from "./AdditionalData.vue?vue&type=script&lang=js"

import "./AdditionalData.vue?vue&type=style&index=0&id=b3315e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3315e42"]])

export default __exports__